import React from "react";
import { FiRefreshCcw, FiLink } from "react-icons/fi";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "./styles.css";

const ButtonComponent = (props) => {
    const { id, handleClick, title } = props;
    return (
        <OverlayTrigger
            placement={"top"}
            overlay={<Tooltip className={"tooltip"}>{title}</Tooltip>}
        >
            <button className="button" id={id} onClick={handleClick}>
                {id === "shareButton" ? (
                    <FiLink size={20} />
                ) : (
                    <FiRefreshCcw size={20} />
                )}
            </button>
        </OverlayTrigger>
    );
};

export default ButtonComponent;
